import { getSession } from "@/auth-client";
import { AppSidebar } from "@/components/app-sidebar";
import { MobileHeader } from "@/components/mobile-header";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(dashboard)/_authenticated")({
  beforeLoad: async ({ location, context }) => {
    const session = await context.queryClient.ensureQueryData({
      queryKey: ["session"],
      queryFn: () => getSession(),
    });

    if (!session) {
      throw redirect({
        to: "/login",
        search: {
          redirectTo: location.href,
        },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="flex-1 w-full min-w-0 overflow-x-hidden">
        <MobileHeader />
        <div className="mx-auto max-w-7xl w-full p-4 pt-20 sm:px-6 lg:px-8 md:pt-8">
          <Outlet />
        </div>
      </main>
    </SidebarProvider>
  );
}
